import React from 'react';
import PropTypes from 'prop-types';
import money from 'money-math';

import Page from 'components/Page';
import {BigRedButton} from 'components/Button';

import '../../../flows/invest/agreement/style.css';

/* eslint-disable max-len */
const InvestAgreement = ({next, allocation}) => (
  <section className="pageContainer">
    <Page>
      <h2>Closing Documents</h2>
      <p>I agree to the <a href={`/docs/deal/unsigned/${allocation.deal.id}`} target="_blank" rel="noopener noreferrer">closing documents’</a> provisions including:</p>
      <ul styleName="terms">
        <li>I’m contributing <strong>${money.format('USD', money.floatToAmount(allocation.investment.allocated / 100))}</strong> to a fund, <strong>{allocation.deal.series.name}</strong>, that will invest in {allocation.deal.asset.name}</li>
        <li>I’m <strong>not investing directly</strong> into the asset and will not have direct investor rights</li>
        <li>I must do my <strong>own due diligence</strong> and have read the closing documents</li>
        <li>Investing with {allocation.syndicate.name}, {allocation.deal.sponsor.name} or Cove <strong>doesn&#39;t guarantee any diligence</strong> on this investment</li>
      </ul>
      <p>You are also certifying a <a href={`/docs/w9/${allocation.id}`} target="_blank" rel="noopener noreferrer">IRS Form W-9</a> (Request for Taxpayer Identification Number and Certification) generated for you by Cove:</p>
      <ul styleName="terms">
        <li>I understand the information provided by me in the Form W-9 will be used by Cove for tax reporting purposes</li>
        <li>I have checked the validity of my IRS Form W-9 linked above and certify it is correct, under penalties of perjury</li>
      </ul>
      <p>You&#39;ll receive signed copies of the closing documents via email when the deal closes.</p>
      <footer styleName="footer">
        <BigRedButton onClick={next} data-test="agree">
          I agree to these terms
        </BigRedButton>
      </footer>
    </Page>
  </section>
);
/* eslint-enable max-len */

// TODO: finish adding detailed propTypes here
InvestAgreement.propTypes = {
  next: PropTypes.func.isRequired,
  allocation: PropTypes.shape({
    investment: PropTypes.shape({
      allocated: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

export default InvestAgreement;



// WEBPACK FOOTER //
// ./web/flows/invest/agreement/component.js